// Utility function for smooth scrolling to sections
export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  }
};

// Utility function to handle navigation with delay for modals
export const navigateToSection = (sectionId: string, delay: number = 0) => {
  setTimeout(() => {
    scrollToSection(sectionId);
  }, delay);
};